module.exports = __webpack_public_path__ + "static/img/case1con.f944b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coorperation/case1con.png
// module id = YknB
// module chunks = 6